import React from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";

export default function Mobile({ children }) {
  const matches = useMediaQuery("(max-width:1023px)");

  return matches ? <>{children}</> : <></>;
}
